import { FilterAPI } from '@philips-emr/tws-components';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

export default class FilterService {

  static restoreFilterState({ target }: MountEvent, parameters?: {}): void {
    const api = target as FilterAPI;

    const restore = api.restoreState(true);

    if (restore) return;

    const startDate = new Date();
    const endDate = new Date();
    startDate.setMonth(startDate.getMonth() - 12);

    api.setData({
      dtInicio: this.formatDate(startDate),
      dtFim: this.formatDate(endDate),
      ...parameters,
    });

  }

  static persistFilterState({ target }: MountEvent): void {
    const api = target as FilterAPI;
    api.persistState();
  }

  private static formatDate(date: Date): string {
    return date.toISOString().slice(0, 10);
  }

}
